import { makeStyles, createStyles, Theme } from 'styles/utils';

export const useStyles = makeStyles((_theme: Theme) => createStyles({
  viewMode: {
  },
  editMode: {
    '& [class*="MuiCard-root"]': {
      overflow: 'visible',
    },
  },
  formNotify: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    marginLeft: 0,
    marginRight: 0,
  }
}));
